import { cx } from 'class-variance-authority';
import Link from 'next/link';
import type { HTMLProps } from 'react';

import LandingPageHeroChicletCtaText from './LandingPageHeroChicletCtaText';
import type { LandingPageHeroChicletCtaProps } from './types';

export interface LandingPageHeroChicletCtaLinkProps
  extends LandingPageHeroChicletCtaProps {
  readonly href: string;
  readonly target?: HTMLProps<HTMLAnchorElement>['target'];
  readonly rel?: HTMLProps<HTMLAnchorElement>['rel'];
}

const LandingPageHeroChicletCtaLink = ({
  className,
  label,
  ...props
}: LandingPageHeroChicletCtaLinkProps) => {
  return (
    <Link
      className={cx('leading-[0px]', className)}
      data-cy="landing-page-hero-chiclet-cta"
      {...props}
    >
      <LandingPageHeroChicletCtaText label={label} />
    </Link>
  );
};

export default LandingPageHeroChicletCtaLink;
